<div class="content">
  <Info
    title="Welk type woning wenst u aan te kopen?"
    details={window.zoekModalOptions.type_woning_text}
    imgSrc={window.zoekModalOptions.type_woning_image} />
  <div class="inputs">
    <span>Meerdere antwoorden mogelijk</span>

    <div>
      {#each values as { key, name, img, value }}
        <div class="input-wrap">
          <input id={`input-${key}`} type="checkbox" name="2-house" {value} bind:group={houses} />
          <label for={`input-${key}`}>
            <div class="img-wrap">
              <img src={img} alt="house" />
            </div>
            <div class="name">
              <Check />
              <span>{name}</span>
            </div>
          </label>
        </div>
      {/each}
    </div>
  </div>
</div>

<script>
  import Info from "./Info.svelte";
  import Check from "./Check.svelte";
  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();
  let houses = [];
  $: dispatch('complete', houses.length > 0);
  const values = [
    {
      key: 9,
      name: "Appartement",
      img: window.zoekModalOptions.apartment_image,
      value: 'apartement'
    },
    {
      key: 10,
      name: "Villa",
      img: window.zoekModalOptions.villa_image,
      value: 'villa'
    },
    {
      key: 11,
      name: "Penthouse",
      img: window.zoekModalOptions.penthouse_image,
      value: 'penthouse'
    },
    {
      key: 12,
      name: "Townhouse",
      img: window.zoekModalOptions.townhouse_image,
      value: 'townhouse'
    }
  ];
</script>

<style lang="postcss">
  .content {
    @apply relative mx-5 pt-8 leading-7;
  }

  .inputs {
    @apply p-12 pt-16 border border-t-0;
  }

  .inputs > span {
    @apply inline-block w-full mb-5 text-center;
  }

  .img-wrap {
    padding-bottom: 50%;
    @apply relative w-full;
  }

  .img-wrap img {
    @apply absolute w-full h-full object-cover;
  }

  label {
    @apply relative mt-5 block;
  }

  .name {
    @apply px-5 py-6 flex border items-center;
  }

  label span {
    @apply ml-5;
  }

  input:checked + label .name {
    @apply bg-primary border-primary;
  }

  input:checked + label span {
    @apply text-white;
  }

  input:checked + label :global(svg path) {
    display: initial;
  }

  input {
    @apply hidden;
  }

  @screen sm {
    .content {
      @apply mx-12;
    }

    .inputs {
      @apply p-16 mr-16;
    }

    .content :global(.details p) {
      @apply w-full pr-16;
    }

    .inputs > span {
      @apply text-left;
    }

    .inputs > div {
      @apply flex flex-wrap;
    }

    .input-wrap {
      @apply w-1/2 px-2;
    }
  }

  @screen md {
    .content :global(.info) {
      @apply pb-0;
    }
    .content :global(.details p) {
      @apply w-auto px-0;
    }
    
    .content {
      @apply flex items-start;
    }

    .content :global(.info) {
      @apply bg-white;
    }

    .inputs {
      @apply mt-10 -ml-16 pl-32 border-t w-full mr-20;
    }

    .inputs > div {
      @apply max-w-2xl;
    }

    label {
      @apply w-full;
    }
  }
</style>
